/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { PortfolioWork } from './PortfolioWork'
import {
  PortfolioWorkFromJSON,
  PortfolioWorkFromJSONTyped,
  PortfolioWorkToJSON,
} from './PortfolioWork'

/**
 *
 * @export
 * @interface CustomContentJSON
 */
export interface CustomContentJSON {
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  block1?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  block2?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  block3?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  header?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  subheader?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  name?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  inn?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  phone?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  ogrn?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  address?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  email?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  title?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  subtitle?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  tabs?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  text?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  comment?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  link?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  channelLink?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  formSubtitle?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  formTitle?: string | null
  /**
   *
   * @type {string}
   * @memberof CustomContentJSON
   */
  portfolioIds?: string | null
  /**
   *
   * @type {Array<PortfolioWork>}
   * @memberof CustomContentJSON
   */
  portfolios?: Array<PortfolioWork> | null
}

/**
 * Check if a given object implements the CustomContentJSON interface.
 */
export function instanceOfCustomContentJSON(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function CustomContentJSONFromJSON(json: any): CustomContentJSON {
  return CustomContentJSONFromJSONTyped(json, false)
}

export function CustomContentJSONFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomContentJSON {
  if (json === undefined || json === null) {
    return json
  }
  return {
    block1: !exists(json, 'block1') ? undefined : json['block1'],
    block2: !exists(json, 'block2') ? undefined : json['block2'],
    block3: !exists(json, 'block3') ? undefined : json['block3'],
    header: !exists(json, 'header') ? undefined : json['header'],
    subheader: !exists(json, 'subheader') ? undefined : json['subheader'],
    name: !exists(json, 'name') ? undefined : json['name'],
    inn: !exists(json, 'inn') ? undefined : json['inn'],
    phone: !exists(json, 'phone') ? undefined : json['phone'],
    ogrn: !exists(json, 'ogrn') ? undefined : json['ogrn'],
    address: !exists(json, 'address') ? undefined : json['address'],
    email: !exists(json, 'email') ? undefined : json['email'],
    title: !exists(json, 'title') ? undefined : json['title'],
    subtitle: !exists(json, 'subtitle') ? undefined : json['subtitle'],
    tabs: !exists(json, 'tabs') ? undefined : json['tabs'],
    text: !exists(json, 'text') ? undefined : json['text'],
    comment: !exists(json, 'comment') ? undefined : json['comment'],
    link: !exists(json, 'link') ? undefined : json['link'],
    channelLink: !exists(json, 'channelLink') ? undefined : json['channelLink'],
    formSubtitle: !exists(json, 'formSubtitle') ? undefined : json['formSubtitle'],
    formTitle: !exists(json, 'formTitle') ? undefined : json['formTitle'],
    portfolioIds: !exists(json, 'portfolioIds') ? undefined : json['portfolioIds'],
    portfolios: !exists(json, 'portfolios')
      ? undefined
      : json['portfolios'] === null
      ? null
      : (json['portfolios'] as Array<any>).map(PortfolioWorkFromJSON),
  }
}

export function CustomContentJSONToJSON(value?: CustomContentJSON | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    block1: value.block1,
    block2: value.block2,
    block3: value.block3,
    header: value.header,
    subheader: value.subheader,
    name: value.name,
    inn: value.inn,
    phone: value.phone,
    ogrn: value.ogrn,
    address: value.address,
    email: value.email,
    title: value.title,
    subtitle: value.subtitle,
    tabs: value.tabs,
    text: value.text,
    comment: value.comment,
    link: value.link,
    channelLink: value.channelLink,
    formSubtitle: value.formSubtitle,
    formTitle: value.formTitle,
    portfolioIds: value.portfolioIds,
    portfolios:
      value.portfolios === undefined
        ? undefined
        : value.portfolios === null
        ? null
        : (value.portfolios as Array<any>).map(PortfolioWorkToJSON),
  }
}
